import ProductDescription from './ProductDescription';
import ProductInformation from './ProductInformation';

type Props = {
  showEditorialPolicy?: boolean;
};

const ProductDetails = ({ showEditorialPolicy }: Props) => {
  return (
    <div className="flex flex-col gap-10">
      <ProductDescription showEditorialPolicy={showEditorialPolicy} />
      <div className="hidden lg:block">
        <ProductInformation />
      </div>
    </div>
  );
};

export default ProductDetails;
